import { CustomColumn } from '../../../../types/customColumn';

export const standardProductColumns: CustomColumn<any>[] = [
  {
    Header: '#',
    id: 'rowIndex',
    accessor: 'id',
    customCell: (cell: any) => {
      const index = cell.row.index;
      const { pageIndex = 0, pageSize = 10 } = cell.table?.state || {};
      return pageIndex * pageSize + index + 1;
    },
  },
  { Header: 'Producto', accessor: 'productName' },
  { Header: 'Cantidad', accessor: 'quantity' },
  { Header: 'Costo Unitario', accessor: 'unitCost' },
  { Header: 'IVA Total', accessor: 'ivaTotal' },
  { Header: 'Total Costo', accessor: 'totalCost' },
];
